import { graphql } from "gatsby"
import React from "react"

import ResourceGroup from "./group"
import Resource from "./resource"

type ResourceListProps = {
  items: ReadonlyArray<Queries.ResourceListItemFragment>
}

export default function ResourceList(props: ResourceListProps) {
  const { resourceGroups, restResources } = props.items.reduce<{
    resourceGroups: Queries.ResourceGroupFragment[]
    restResources: Queries.ResourceFragment[]
  }>(
    (result, resource) => {
      if (resource.__typename === "ContentfulResourceGroup")
        return {
          ...result,
          resourceGroups: [...result.resourceGroups, resource]
        }

      if (resource.__typename === "ContentfulResource")
        return { ...result, restResources: [...result.restResources, resource] }

      return result
    },
    { resourceGroups: [], restResources: [] }
  )

  return (
    <div className="space-y-12 md:space-y-16">
      {resourceGroups.length > 0 ? (
        <>
          {resourceGroups.map(group => (
            <ResourceGroup {...group} key={group.contentful_id} />
          ))}

          {restResources.length > 0 && (
            <ResourceGroup
              title="Other Resources"
              description={null}
              resources={restResources}
            />
          )}
        </>
      ) : (
        restResources.map(resource => (
          <Resource {...resource} key={resource.contentful_id} />
        ))
      )}
    </div>
  )
}

export const fragment = graphql`
  fragment ResourceListItem on ContentfulResourceContentfulResourceGroupUnion {
    __typename
    ...Resource
    ...ResourceGroup
  }
`
